import { Text } from "./Text";
import type { MessagingMessage } from "@/model/messaging";

export const Email = ({ message }: { message: MessagingMessage }) => {
  const {
    payload: { email },
  } = message;

  return (
    <div className="text-sm">
      <div className="flex flex-wrap gap-2">
        <div className="font-semibold">To</div>
        <p className="break-all">{email?.target}</p>
      </div>
      {(email?.cc ?? [])?.length > 0 && (
        <div className="flex flex-wrap gap-2">
          <div className="font-semibold">Cc</div>
          <p className="break-all">{email?.cc?.join("; ")}</p>
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        <div className="font-semibold">Subject</div>
        <p className="break-all">{email?.subject}</p>
      </div>
      <Text message={message} />
    </div>
  );
};
